define('views/shared/phone/phone_carousel',[
	'backbone',
	'views/_base/baseview',
	'text!views/shared/phone/phone_carousel.html',
	'views/shared/phone/phone',
	'views/shared/bullet_nav/bullet_nav',
	'views/shared/phone/phone_carousel_item'
], function(Backbone, BaseView, Template, PhoneComponent, BulletNavComponent, PhoneItemComponent){
	'use strict';

	return BaseView.extend({
		tagName  : 'div',
		className: 'series-wrap-container',
		template : _.template(Template),
		isRender : true,
		events   : {},

		initialize: function(options){
			options = options || {};

			this.elementName = options.elementName;

			this.items = options.items;
			this.site_version = pf.getContent('version.id');
			this.subviews = {};
			this.coords = {
				window: {},
				seriesWrap: {},
				seriesItems: []
			};

			this.window = $(window);

			if (this.site_version !== enums.siteVersion.almyblue) {
				_.bindAll(this, 'checkScroll');
				_.bindAll(this, 'handleScreenResize');
				_.bindAll(this, 'scrollToSeriesItem');
				_.bindAll(this, 'updateStaticCoords');	
			}
			
			BaseView.prototype.initialize(this);
		},

		render: function(){

			this.$el.html(this.template());

			this.addPhoneAnimation();


			return this;
		},

		addPhoneAnimation: function(){

			if(_.isArray(this.items)){

				var that = this;

				this.items.forEach(function(item, index){
					
					var phone_item = new PhoneItemComponent({ item: item });

					that.$('#series-wrap').append(phone_item.el);

					var phone_component_data = {
						elementName : item.id,
						phoneTypeID : enums.phoneTypeID.iphone,
						phoneShell  : 'img/phone/iphone/shells/iphone_8_white.png',
						phoneScreen : item.screen,
						app_store_icons: item.app_store_icons
					}

					if(index == 0){
						phone_component_data.class = 'js-partner-root-phone-carousel partner-root-phone-carousel'
					}

					var phone_component = new PhoneComponent(phone_component_data);

					if(index == 0){
						that.subviews.phone_carousel = phone_component;
					}

					that.$el.find('#' + item.id).html(phone_component.el);

				});

				this.phone_carousel = this.$el.find('.js-partner-root-phone-carousel');
				this.carousel_container = this.$el.find('#series-wrap');
				this.carousel_items = this.$el.find('.js-series-item');
				this.bullet_navigation = this.$el.find('#partner-root-bullet-nav-wrap');

				if (this.site_version !== enums.siteVersion.almyblue) {
					this.updateStaticCoords();
					this.enableCheckScroll();
				}



				this.subviews.bullet_navigation = new BulletNavComponent({
					elementName  : '#partner-root-bullet-nav-wrap',
					bulletCount  : this.carousel_items.length,
					isVertical   : true,
					isInteractive: true,
					callback     : this.scrollToSeriesItem
				});

				if (this.site_version !== enums.siteVersion.almyblue) {
					setTimeout(this.updateStaticCoords, 3000);	
				}

			}

		},

		/* ---------------------------------------------------------------------
			Element Coordinates
		--------------------------------------------------------------------- */ 

		updateStaticCoords: function(){
			this.coords.window.width = this.window.width();
			this.coords.window.height = this.window.height();

			this.coords.seriesWrap.top = this.carousel_container.offset().top;

			var that = this;
			this.coords.seriesItems = [];
			this.carousel_items.each(function(index){

				var item = $(this),
					itemCoords = {
						top:    item.offset().top,
						center: item.offset().top + ( item.height() / 2 ),
						bottom: item.offset().top + item.height() -1 // minus 1 so item bottom is different than next item top
					};

				that.coords.seriesItems.push(itemCoords);

			});
		},

		updateVariableCoords: function(){
			this.coords.window.center = this.window.scrollTop() + ( this.window.height() / 2);
		},

		getCurrentSeriesItem: function(){
			var currentSeriesItem;

			for(var i = 0; i < this.coords.seriesItems.length; i++){

				var coords = this.coords.seriesItems[i];

				if (this.coords.window.center >= coords.top && this.coords.window.center <= coords.bottom) {
					currentSeriesItem = i;
					break;
				}

			}

			return currentSeriesItem;
		},




		/* ---------------------------------------------------------------------
			Phone
		--------------------------------------------------------------------- */ 

		// Phone
		unfixPhone: function(){
			this.phone_carousel.css({
				position : '',
				top      : '',
				width    : '',
				transform: ''
			});
			this.setCurrentPhoneScreen();
		},

		fixPhoneCenter: function(){
			this.phone_carousel.css({
				position : 'fixed',
				top      : '50%',
				width    : '300px',
				transform: 'translate3d(0, -50%, 0)'
			});
		},

		fixPhoneBottom: function(){
			this.phone_carousel.css({
				position : 'absolute',
				top      : ( (this.coords.seriesItems.slice(-1)[0].center - this.coords.seriesWrap.top) + 'px' ),
				width    : '300px',
				transform: 'translate3d(0, -50%, 0)'
			});
		},

		setCurrentPhoneScreen: function(index){
			index = index || 0;
			this.subviews.phone_carousel.setCurrentPhoneScreen(index);
			this.subviews.bullet_navigation.setActiveBullet(index);
		}, 




		/* ---------------------------------------------------------------------
			Bullet Nav
		--------------------------------------------------------------------- */ 

		showBulletNav: function() {
			this.bullet_navigation.addClass('partner-root-bullet-nav-wrap--visible');
		},

		hideBulletNav: function() {
			this.bullet_navigation.removeClass('partner-root-bullet-nav-wrap--visible');
		},
		



		/* ---------------------------------------------------------------------
			Scroll & Window Changes
		--------------------------------------------------------------------- */ 

		checkScroll: function(){
			this.updateVariableCoords();

			// XS-SM Layout: Phone and content stacked
			if (this.coords.window.width < 768) {
				this.unfixPhone();
				this.hideBulletNav();

			// MD-XL Layout: Phone and content side-by-side
			} else {
				// Window vertical center is...

				// ... above vertical center of first series item.
				if (this.coords.window.center < this.coords.seriesItems[0].center) {
					this.unfixPhone();
					this.hideBulletNav();

				// ... below vertical center of first series item and...
				} else {
					// ... above vertical center of last series item
					if (this.coords.window.center <= this.coords.seriesItems.slice(-1)[0].center) {
						this.fixPhoneCenter();
						this.setCurrentPhoneScreen( this.getCurrentSeriesItem() );
						this.showBulletNav();

					// ... below vertical center of last series item
					} else {
						this.fixPhoneBottom();
						this.hideBulletNav();
					}
				}
			}
		},

		handleScreenResize: function(){
			this.updateStaticCoords();
			this.checkScroll();
		},

		enableCheckScroll: function(){
			this.window.on('scroll', this.checkScroll);
			this.window.on('resize', this.handleScreenResize);
			this.window.on("orientationchange", this.handleScreenResize);
		},

		disableCheckScroll: function(){
			this.window.off('scroll', this.checkScroll);
			this.window.off('resize', this.handleScreenResize);
			this.window.off("orientationchange", this.handleScreenResize);
		},

		scrollToSeriesItem: function(index){
			var that = this;
			$('html, body').animate({
				scrollTop: that.coords.seriesItems[index].center - (that.coords.window.height / 2)
			}, 500);
		},
	 
		close: function(){

			this.unbind();
			this.disableCheckScroll();

			if(this.site_version != enums.siteVersion.payforward){
				this.cleanup(this.subviews.joinJumbotron);
			}

			this.cleanup(this.subviews.bullet_navigation);
			this.cleanup(this.subviews.phone_carousel);
			this.cleanup(this.subviews.phoneGetPaid);
		}
	});
});
